import {
  FilterButton,
  ModalBodyText,
  ModalContainer,
  ModalForm,
  ModalFormActions,
  ModalTitle,
} from "../AdminPage.styles";

interface ISendEnrolmentEmailModalProps {
  newEmail: string;
  isSaving: boolean;
  /** Both answers save; the flag decides whether the email goes out. */
  onAnswer: (sendEnrolmentEmail: boolean) => void;
  onCancel: () => void;
}

/**
 * Asked when a patient's login email changes (EN-5169) — Retool's
 * `sendEnrolmentModal`.
 *
 * Three answers, not two. Retool offered "Send" and "Don't send" and both
 * saved, with no way out: once the form was submitted the email change was
 * going to be written either way, so an operator who realised mid-prompt that
 * they had the wrong address had to save and then correct it. Cancel leaves the
 * form as it is.
 */
export function SendEnrolmentEmailModal({
  newEmail,
  isSaving,
  onAnswer,
  onCancel,
}: ISendEnrolmentEmailModalProps) {
  return (
    <ModalContainer>
      <ModalTitle>Send enrolment email?</ModalTitle>
      <ModalForm>
        <ModalBodyText>
          This patient&apos;s sign-in email is changing to{" "}
          <strong>{newEmail}</strong>. Send the enrolment email to the new
          address so they can set a password for it?
        </ModalBodyText>
        <ModalBodyText>
          Either answer saves the new address. Choose{" "}
          <strong>Don&apos;t send</strong> if you are correcting a typo in an
          address the patient already uses.
        </ModalBodyText>
        <ModalFormActions>
          <FilterButton
            variant="secondary"
            disabled={isSaving}
            onClick={onCancel}
          >
            Cancel
          </FilterButton>
          <FilterButton
            variant="secondary"
            disabled={isSaving}
            onClick={() => onAnswer(false)}
          >
            {isSaving ? "Saving..." : "Don't send"}
          </FilterButton>
          <FilterButton
            variant="primary"
            disabled={isSaving}
            onClick={() => onAnswer(true)}
          >
            {isSaving ? "Saving..." : "Save and send"}
          </FilterButton>
        </ModalFormActions>
      </ModalForm>
    </ModalContainer>
  );
}
